<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="商品名" label-width="80px">
        <el-input v-model="searchForm.name" clearable placeholder="商品名">
        </el-input>
      </el-form-item>
      <el-form-item label="商品类型" label-width="80px">
        <el-cascader
          ref="cateData"
          v-model="classifyId"
          :options="typeList"
          :props="{
            checkStrictly: true,
            value: 'id',
            label: 'name',
            children: 'children',
          }"
          clearable
          filterable
          placeholder="选择分类"
          @change="onSelectPMenu"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="getStoreGoods(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="getod()">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="hasAuth('sys:singProduct:add')"
          type="primary"
          @click="addUpdateGoodsButton('', '')"
          >添加商品
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="hasAuth('sys:singProduct:dels')"
          plain
          type="danger"
          @click="delHandle(null)"
          >批量删除
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      element-loading-background="rgba(0, 0, 0, 0.8)"
      element-loading-spinner="el-icon-loading"
      element-loading-text="拼命加载中"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
    >
      <el-table-column align="center" type="selection" width="50" />
      <el-table-column
        align="center"
        label="商品封面"
        prop="storeGoodsCover"
        width="100"
      >
        <template slot-scope="scope">
          <el-image
            :src="scope.row.cover"
            fit="scale-down"
            style="width: 70px; height: 70px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品名称"
        prop="name"
        width="260"
      ></el-table-column>

      <el-table-column align="center" label="商品分类" width="148">
        <template slot-scope="scope">
          {{ scope.row.classifyName }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品备注" width="148">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.isGroupBuying == 1"
            size="small"
            type="success"
            >拼团商品
          </el-tag>
          <el-tag v-if="scope.row.isHot == 1" size="small" type="success"
            >热门商品
          </el-tag>
          <el-tag
            v-if="scope.row.isLimitedTimeDiscount == 1"
            size="small"
            type="success"
            >限时秒杀
          </el-tag>
          <el-tag v-if="scope.row.isPoint == 1" size="small" type="success"
            >积分兑换
          </el-tag>
          <el-tag v-if="scope.row.isRecommend == 1" size="small" type="success"
            >推荐商品
          </el-tag>
          <el-tag
            v-if="scope.row.isCrowdfunding == 1"
            size="small"
            type="success"
            >众筹商品
          </el-tag>
          <el-tag v-if="scope.row.isGift == 1" size="small" type="success"
            >赠品
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品规格"
        prop="parameters"
        width="400"
      >
        <template slot-scope="{ row }">
          <div
            v-for="(item, index) in row.commoditSpecificationsList"
            :key="index"
          >
            规格名：{{ item.commoditSpecifications }}；原价：{{
              item.originalPrice
            }}
            ； {{ item.sellingPriceName || "售价" }}：{{ item.price }}；
            {{ item.storePriceName || "达人价" }}：{{ item.storePrice }}；

            <span v-if="row.isGroupBuying == 1"
              >拼团价：{{ item.groupBuyingPrice || 0 }}；</span
            >
            <span v-if="row.isLimitedTimeDiscount == 1"
              >秒杀价：{{ item.limitedTimeDiscountPrice || 0 }}；</span
            >
            <span v-if="row.isCrowdfunding == 1"
              >全款众筹价：{{ item.crowdfundingPrice || 0 }}；</span
            >
            <span v-if="row.isCrowdfunding == 1"
              >抽奖众筹价：{{ item.crowdfundingLotteryPrice || 0 }}；</span
            >
            <span v-if="row.isPoint == 1"
              >兑换积分：{{ item.exchangePointsNum || 0 }}；</span
            >
            <span v-if="row.isGift == 1"
              >库存：{{ item.inventory || 0 }}；</span
            >
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="商品标签"
        prop="parameters"
        width="300"
      >
        <template slot-scope="{ row }">
          <div v-for="(item, index) in row.productLabelsList" :key="index">
            {{ item }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品销量"
        prop="salesVolume"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        label="是否为赠品"
        prop="isGift"
        width="140"
      >
        <template slot-scope="{ row }">
          {{ row.isGift == 1 ? "是" : "否" }}
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="商品参数"
        prop="parameters"
        width="150"
      ></el-table-column>
      <el-table-column
        align="center"
        label="排序"
        prop="sort"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="380"
      >
        <template slot-scope="scope">
          <el-button
            v-if="hasAuth('sys:singProduct:shangjia')"
            slot="reference"
            plain
            type="success"
            @click="updStoreGoodsIsOnframe(scope.row)"
          >
            上架
          </el-button>
          <el-button
            v-if="hasAuth('sys:singProduct:edit')"
            plain
            type="primary"
            @click="addUpdateGoodsButton(scope.row, 1)"
            >编辑
          </el-button>
          <el-button plain type="primary" @click="lookinfo(scope.row)"
            >详情
          </el-button>
          <el-button
            v-if="hasAuth('sys:singProduct:fuzhi')"
            plain
            type="primary"
            @click="addUpdateGoodsButton(scope.row, '')"
            >复制
          </el-button>
          <el-button
            v-if="scope.row.isOnframe != 0 && hasAuth('sys:singProduct:del')"
            slot="reference"
            plain
            type="danger"
            @click="delHandle(scope.row.id)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="current"
      :page-size="size"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="smvisible"
      append-to-body
      class="dialogClass"
      title="详情"
      width="1000px"
    >
      <div class="flexcen">
        <div class="titcon">商品名称</div>
        <div class="">{{ shopinfo.name }}</div>
      </div>

      <div class="flexcen" style="color: red" v-if="shopinfo.status == 2">
        <div class="titcon">审核状态</div>
        <div class="">审核驳回</div>
      </div>
      <div class="flexcen" style="color: red" v-if="shopinfo.status == 2">
        <div class="titcon">审核说明</div>
        <div class="">{{ shopinfo.reason }}</div>
      </div>

      <div class="flexcen">
        <div class="titcon">单位</div>
        <div class="">{{ shopinfo.unit }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品参数</div>
        <div class="">{{ shopinfo.parameters }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">运费</div>
        <div class="">{{ shopinfo.freight }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">排序</div>
        <div class="">{{ shopinfo.sort }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品标签</div>
        <div class="">
          <el-tag
            v-for="(tag, i) in shopinfo.productLabelsList"
            :key="i"
            size="mini"
            >{{ tag }}</el-tag
          >
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">属性</div>
        <div class="">
          <el-tag v-if="shopinfo.isHot === 1" size="mini">热门</el-tag>
          <el-tag v-if="shopinfo.isRecommend === 1" size="mini">推荐</el-tag>
          <el-tag v-if="shopinfo.isNewProductLaunch === 1" size="mini"
            >新品</el-tag
          >
          <el-tag v-if="shopinfo.isGift === 1" size="mini">赠品</el-tag>
          <el-tag v-if="shopinfo.isPoint === 1" size="mini">积分兑换</el-tag>
          <el-tag v-if="shopinfo.isGroupBuying === 1" size="mini">拼团</el-tag>
          <el-tag v-if="shopinfo.isLimitedTimeDiscount === 1" size="mini"
            >限时秒杀</el-tag
          >
          <el-tag v-if="shopinfo.isCrowdfunding === 1" size="mini">众筹</el-tag>
        </div>
      </div>
      <div v-if="shopinfo.isGroupBuying === 1" class="flexcen">
        <div class="titcon">拼团人数</div>
        <div class="">{{ shopinfo.groupBuyingNum }}</div>
      </div>
      <div v-if="shopinfo.isLimitedTimeDiscount === 1" class="flexcen">
        <div class="titcon">秒杀人数</div>
        <div class="">{{ shopinfo.limitedTimeDiscountNum }}</div>
      </div>
      <div v-if="shopinfo.isLimitedTimeDiscount === 1" class="flexcen">
        <div class="titcon">秒杀截止</div>
        <div class="">{{ shopinfo.limitedTimeDiscountEndTime }}</div>
      </div>
      <div v-if="shopinfo.isLimitedTimeDiscount === 1" class="flexcen">
        <div class="titcon">秒杀件数</div>
        <div class="">{{ shopinfo.limitedTimeDiscountCommodityNum }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">众筹开始</div>
        <div class="">{{ shopinfo.crowdfundingStartTime }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">众筹结束</div>
        <div class="">{{ shopinfo.crowdfundingEndTime }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">发货时间</div>
        <div class="">{{ shopinfo.crowdfundingDeliveryTime }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">可抽奖人数</div>
        <div class="">{{ shopinfo.crowdfundingLuckyNum }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">幸运用户数</div>
        <div class="">{{ shopinfo.crowdfundingLuckyUser }}</div>
      </div>
      <div style="height: 20px"></div>
      <div class="issline"></div>
      <div style="height: 20px"></div>
      <div>
        <div class="mb8">商品规格</div>
        <el-table
          :data="shopinfo.commoditSpecificationsList || []"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="commoditSpecifications"
            label="规格名"
            min-width="140"
          ></el-table-column>
          <el-table-column
            prop="originalPrice"
            label="原价"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="price"
            :label="
              shopinfo.commoditSpecificationsList &&
              shopinfo.commoditSpecificationsList.length > 0 &&
              shopinfo.commoditSpecificationsList[0].sellingPriceName
                ? shopinfo.commoditSpecificationsList[0].sellingPriceName
                : '售价'
            "
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="storePrice"
            :label="
              shopinfo.commoditSpecificationsList &&
              shopinfo.commoditSpecificationsList.length > 0 &&
              shopinfo.commoditSpecificationsList[0].storePriceName
                ? shopinfo.commoditSpecificationsList[0].storePriceName
                : '达人价'
            "
            min-width="100"
          ></el-table-column>

          <el-table-column
            v-if="shopinfo.isGift === 1"
            prop="inventory"
            label="库存"
            min-width="100"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isGroupBuying === 1"
            prop="groupBuyingPrice"
            label="拼团价"
            min-width="100"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isLimitedTimeDiscount === 1"
            prop="limitedTimeDiscountPrice"
            label="秒杀价"
            min-width="100"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isCrowdfunding === 1"
            prop="crowdfundingPrice"
            label="全款众筹价"
            min-width="120"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isCrowdfunding === 1"
            prop="crowdfundingLotteryPrice"
            label="抽奖众筹价"
            min-width="120"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isPoint === 1"
            prop="exchangePointsNum"
            label="兑换积分"
            min-width="100"
          ></el-table-column>
        </el-table>
        <div
          v-for="(spec, sIndex) in shopinfo.commoditSpecificationsList || []"
          :key="sIndex"
          style="margin-top: 10px"
        >
          <div
            v-if="
              spec.tcommodityFlashSalePrices &&
              spec.tcommodityFlashSalePrices.length > 0
            "
          >
            <div class="mb8">规格 {{ sIndex + 1 }} 阶梯单价</div>
            <el-table
              :data="spec.tcommodityFlashSalePrices"
              border
              stripe
              style="width: 100%"
            >
              <el-table-column
                prop="startNum"
                label="开始数量"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="endNum"
                label="结束数量"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="price"
                label="每件单价/元"
                min-width="140"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div style="height: 20px"></div>
      <div class="issline"></div>
      <div style="height: 20px"></div>
      <div class="flexcen">
        <div class="titcon">封面</div>
        <div class="">
          <img
            v-for="(cover, i) in shopinfo.videoCoverList"
            :key="i"
            :src="cover"
            alt=""
            class="stimg"
          />
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">轮播图</div>
        <div class="">
          <img
            v-for="(img, i) in shopinfo.imgListArray"
            :key="i"
            :src="img"
            alt=""
            class="stimg"
          />
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品说明</div>
        <div class="" v-html="shopinfo.explain"></div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品详情</div>
        <div class="" v-html="shopinfo.imgDetail"></div>
      </div>
      <div class="flexcen">
        <div class="titcon">三证信息</div>
        <div class="" v-html="shopinfo.threeCertificateInformation"></div>
      </div>
    </el-dialog>
    <div v-if="dialog">
      <Sing ref="addUpdateSingProduct" @refreshDataList="getStoreGoods"></Sing>
    </div>
    <BalancePayment
      v-if="balancePaymentVisble"
      ref="balancePayment"
      @refreshDataList="getStoreGoods"
    >
    </BalancePayment>
    <AddParameter
      v-if="getParametervisible"
      ref="getParameter"
      @refreshDataList="getStoreGoods"
    ></AddParameter>
  </div>
</template>

<script>
import Sing from "./components/SingProduct";
import BalancePayment from "./BalancePayment";
import AddParameter from "./AddParameter";

export default {
  name: "singProduct",
  components: {
    Sing,
    BalancePayment,
    AddParameter,
  },
  data() {
    return {
      smvisible: false,
      dalong: false,
      sortVisible: false,
      boxItemsVisible: false,
      nonQueuingVisible: false,
      getParametervisible: false,
      dialog: false,
      gardenNames: "",
      shopinfo: "",
      loading: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        classifyFirstId: "",
      },
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      GardenIdList: [],
      typeList: [],
      total: 0,
      size: 10,
      current: 1,
      addUpdateSingProductVisible: false,
      updateGoodssVisible: false,
      balancePaymentVisble: false,
      ids: [],
      classifyId: [],
      supList: [],
    };
  },
  created() {
    this.getStoreGoods();

    this.getTypeList();
    this.supp();
  },
  methods: {
    onSelectPMenu(val) {},
    supp() {
      this.$axios.get("/admin/brand/getBrandListNoPage").then((res) => {
        this.supList = res.data;
      });
    },
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    lookinfo(row) {
      this.$axios
        .post("/admin/commodity/getCommodityDetail", {
          id: row.id,
        })
        .then((res) => {
          this.smvisible = true;
          const data = res.data || {};
          const videoCoverList = data.videoCover
            ? String(data.videoCover).split(",")
            : [];
          const imgListArray = Array.isArray(data.imgList)
            ? data.imgList
            : data.imgList
            ? String(data.imgList).split(",")
            : [];
          if (Array.isArray(data.commoditSpecificationsList)) {
            data.commoditSpecificationsList.forEach((spec) => {
              if (!spec.tcommodityFlashSalePrices) {
                spec.tcommodityFlashSalePrices = [];
              }
            });
          }
          this.shopinfo = Object.assign({}, data, {
            videoCoverList,
            imgListArray,
          });
        });
    },
    getod() {
      this.searchForm = {
        name: "",
        storeGoodsType: "",
        brandId: "",
        classifyFirstId: "",
        classifyId: "",
      };
      this.classifyId = [];
      this.getStoreGoods(1);
    },
    sort(id) {
      this.sortVisible = true;
      this.$nextTick(() => {
        this.$refs.sort.init(id);
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // handleSelectionChange(val) {
    // 	this.multipleSelection = val;
    // 	this.delBtlStatu = val.length == 0
    // },

    handleSizeChange(val) {
      this.size = val;
      this.getStoreGoods();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getStoreGoods();
    },
    addUpdateParameterButton(model) {
      this.getParametervisible = true;
      this.$nextTick(() => {
        this.$refs.getParameter.init(
          model.storeGoodsCartonsId,
          model.storeGoodsId
        );
      });
    },
    //获取园区列表
    // getGardenList(name) {
    // 	this.$axios.post("/admin/singleStoreGoods/getGardenList", {
    // 		name: ''
    // 	}).then(res => {
    // 		this.GardenIdList = res.data;
    // 	})
    // },
    getTypeList() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          this.typeList = res.data;
        });
    },
    getStoreGoods(current) {
      if (this.classifyId.length > 0) {
        this.searchForm.classifyFirstId = this.classifyId[0];
        if (this.classifyId.length > 1) {
          this.typeList.map((item) => {
            item.children.map((itrs) => {
              if (this.classifyId[1] == itrs.id) {
                this.searchForm.classifyId = itrs.uid;
              }
            });
          });
        } else {
          this.searchForm.classifyId = "";
        }
      } else {
        this.searchForm.classifyId = "";
        this.searchForm.classifyFirstId = "";
      }

      if (current) {
        this.current = current;
      }

      this.loading = true;
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/commodity/getLowerCommodityList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.current;
          this.total = res.data.total;
          this.loading = false;
        });
    },

    // 根据id删除数据
    removeById(id) {},

    delHandle(id) {
      var arr = [];
      var txtsd = "";
      if (id) {
        arr.push(id);
        txtsd = "此操作将删除该商品，是否继续?";
      } else {
        if (this.ids.length > 0) {
          arr = this.ids;
          txtsd = "此操作将删除选中商品，是否继续?";
        } else {
          return;
        }
      }
      this.$confirm(txtsd, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/commodity/deleteCommodity", {
            idList: arr,
          })
          .then((res) => {
            this.getStoreGoods();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    addUpdateGoodsButton(model, d) {
      if (model != null) {
        this.dialog = true;
        this.$nextTick(() => {
          this.$refs.addUpdateSingProduct.init(model.id, d);
        });
      } else {
        this.dialog = true;
        this.$nextTick(() => {
          this.$refs.addUpdateSingProduct.init();
        });
      }
    },

    //下架、上架商城商品
    updStoreGoodsIsOnframe(model) {
      var that = this;
      this.$confirm("操作需谨慎：此操作是将该商品上架，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$axios
          .post("/admin/commodity/upperCommodity", {
            id: model.id,
          })
          .then((res) => {
            that.getStoreGoods();
            that.$message({
              showClose: true,
              message: res.msg,
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    //设置是否轮播
    updStoreGoodsIsRotation(id) {
      this.$axios
        .post("/admin/singleStoreGoods/updSingleStoreGoodsIsRotation", {
          storeGoodsId: id,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
            onClose: () => {
              this.getStoreGoods();
            },
          });
        });
    },
    balancePayment(id) {
      this.balancePaymentVisble = true;
      this.$nextTick(() => {
        this.$refs.balancePayment.init(id);
      });
    },
    //设置推荐商城商品
    updStoreGoodsIsRecommend(model) {
      this.$confirm(
        "此操作将是该商品" +
          (model.isRecommend === 0 ? "取消推荐" : "推荐商品") +
          "，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios
          .post("/sysCommodityManagement/setProductRecommendations", {
            id: model.storeGoodsId,
          })
          .then((res) => {
            this.getStoreGoods();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    updStoreGoodsStatus(id) {
      this.updStoreGoodsStatusvisible = true;
      this.$nextTick(() => {
        this.$refs.updStoreGoodsStatus.init(id);
      });
    },
    nonQueuing(id) {
      this.nonQueuingVisible = true;
      this.$nextTick(() => {
        this.$refs.nonQueuing.init(id);
      });
    },
    viewInventory(id) {
      this.boxItemsVisible = true;
      this.$nextTick(() => {
        this.$refs.boxItems.init(id);
      });
    },
    boxRuleButton(id) {
      this.boxRuleVisible = true;
      this.$nextTick(() => {
        this.$refs.boxRule.init(id);
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 30px;
  margin-right: 10px;
  margin-top: 5px;
}

.titcon {
  width: 150px;
}

.flexcen {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.issline {
  height: 1px;
  background: #e1e1e1;
  width: 100%;
}

.stimg {
  width: 50px;
  height: 50px;
  border-radius: 6rpx;
  display: inline-block;
  margin-right: 10rpx;
}

.mb8 {
  margin-bottom: 10px;
}
</style>
